export default __webpack_public_path__ + "static/media/sweet.618ed133.jpg";